import React from "react";
import { useLocation, Link } from "react-router-dom";
import routes from "../../services/routes";

const Breadcrumb = () => {
  const { pathname } = useLocation();

  // Split the current path into an array of parts
  const pathParts = pathname.split("/").filter(Boolean);

  // Generate the breadcrumb links based on the pathParts
  const breadcrumbs = pathParts.map((part, index) => {
    const url = `/${pathParts.slice(0, index + 1).join("/")}`;
    const route = routes.find((route) => route.path === url);
    return {
      label: route ? route.name : part,
      url,
      isActive: index === pathParts.length - 1,
    };
  });

  return (
    <nav className="bg-white py-3 px-4 rounded-lg mx-4 mt-3">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map(({ label, url, isActive }, index) => (
          <li key={index} className="flex items-center">
            {isActive ? (
              <span className="text-gray-700 font-semibold capitalize">
                {label}
              </span>
            ) : (
              <Link
                to={url}
                className="text-blue-600 hover:underline font-Poppins font-medium capitalize"
              >
                {label}
              </Link>
            )}
            {/* Add the separator except for the last breadcrumb */}
            {index < breadcrumbs.length - 1 && (
              <span className="text-gray-500 mx-2 font-bold text-lg">/</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
